const LabelPill = ({ label, size = 'small' }) => {
  if (!label) return null;

  return (
    <span
      className={`label-pill label-pill--${size}`}
      style={{ backgroundColor: label.color }}
      title={label.name}
    >
      {label.name}
    </span>
  );
};

export default LabelPill;
